<div class="modal-header">
  <h4 class="modal-title">
    {{'switchingRailsProblemsPopup.title' | translate}}
  </h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p>{{'switchingRailsProblemsPopup.header.removed_articles' | translate}}</p>
    <table class="table table-hover text-center" fixedHeader>
      <thead>
      <tr>
        <th>{{'projectwizard.columnheader.articlenumber' | translate}}</th>
      </tr>
      </thead>
    </table>
    <div style="min-height: 110px" maxHeightOffset="215">
      <table class="table table-striped table-hover text-center table-wrap table-fixed">
          <tbody>
        <tr *ngFor="let articleNo of unconnectableArticleNumbers">
          <td class="float-none">{{articleNo}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-primary btn-forward"
          type="button"
          (click)="close()">{{'global.label.ok' | translate}}
  </button>
</div>
